module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error/access-denied-full/access-denied-full.component.css
// module id = ./src/app/components/error/access-denied-full/access-denied-full.component.css
// module chunks = main